const Limitations: React.FC<{
  tieredRule: {
    minBundle?: number;
    maxBundle?: number;
  };
  comma?: boolean;
}> = ({ tieredRule, comma }) => {
  if (!tieredRule) return null;
  const { minBundle, maxBundle } = tieredRule;
  if (!minBundle && !maxBundle) return null;
  if (minBundle === maxBundle) {
    return <span>{`限定${maxBundle}套`}</span>;
  }
  if (minBundle === 1) {
    if (maxBundle) return <span>{`限购${maxBundle}套`}</span>;
    return null;
  }
  if (!maxBundle) {
    return <span>{`至少购买${minBundle}套`}</span>;
  }
  return (
    <>
      <span>{`至少购买${minBundle}套`}</span>
      <span>{`${comma ? ", " : ""}最多购买${maxBundle}套`}</span>
    </>
  );
};

export default Limitations;
